<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <app-dwv-tags-table [data]="data.value"></app-dwv-tags-table>
</div>
